// extracted by mini-css-extract-plugin
module.exports = {"container":"styles__container___sTgi2","text":"styles__text___qBh9C","separator":"styles__separator___RLv0x"};